import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import {
  selectAttributeInfo,
  selectDateRange,
} from '../../../store/options/options.selector';
import { selectHazardTextData } from '../../../store/data/data.selector';

import formatNumber from '../../../utilities/formatNumber';

import MarkdownToJsx from '../../markdown-to-jsx/markdown-to-jsx.component';


export default function HazardText({ place }) {
  const dateRange = useSelector(selectDateRange);
  const { count, damageCrops, damageProperty, deaths, injuries } =
    useSelector(selectHazardTextData);
  const attrInfo = useSelector(selectAttributeInfo);
  const attrName = attrInfo.name;

  const eventPlurality = count === 1 ? 'event' : 'events';
  const fullPlurality = count === 1 ? 'This event' : 'These events';

  let text = `In ${place}, data on past ${attrName.toLowerCase()} episodes show that ${place} reported experiencing ${count} ${attrName.toLowerCase()} ${eventPlurality} between ${
    dateRange.start
  } and ${dateRange.end}. ${fullPlurality} resulted in `;

  let buts = [];
  let ins = [];
  let wereWas = 'were';

  if (damageProperty > 0) {
    ins.push(`$${formatNumber(damageProperty)} in reported property damage`);
  } else {
    buts.push('no reported property damage');
    wereWas = 'was';
  }

  if (damageCrops > 0) {
    ins.push(`$${formatNumber(damageCrops)} in reported crop damage`);
  } else {
    buts.push('no reported crop damage');
    wereWas = 'was';
  }

  if (deaths > 0) {
    ins.push(`${deaths} reported deaths`);
  } else {
    buts.push('no reported deaths');
  }

  if (injuries > 0) {
    ins.push(`${injuries} reported injuries`);
  } else {
    buts.push('no reported injuries');
  }

  if (buts.length === 4) {
    text +=
      'no reported property damage, no reported crop damage, no reported injuries, and no reported deaths.';
  } else {
    if (ins.length === 2) {
      text += `${ins[0]} and ${ins[1]}.`;
    } else if (ins.length > 2) {
      text += `${ins.slice(0, ins.length - 1).join(', ')}, and ${ins.slice(
        ins.length - 1
      )}.`;
    } else {
      text += `${ins[0]}.`;
    }

    if (buts.length === 2) {
      text += ` There ${wereWas} ${buts[0]} and ${buts[1]}.`;
    } else if (buts.length > 2) {
      text += ` There ${wereWas} ${buts
        .slice(0, buts.length - 1)
        .join(', ')}, and ${buts.slice(buts.length - 1)}.`;
    } else if (buts.length === 1) {
      text += ` There ${wereWas} ${buts[0]}.`;
    }
  }

  const mdPath = [process.env.PUBLIC_URL, 'markdown', 'hazard_definitions'].join('/');
  const filename = attrName.toLowerCase().split(' ').join('_').replace('-','_').replace('/','_');

  return (
    <>
      <Typography>{text}</Typography>

      <div>
        <MarkdownToJsx path={`${mdPath}/${filename}.md`} />
        <hr style={{ width: '90%', margin: '4px auto 8px auto' }}></hr>
        <MarkdownToJsx path={`${mdPath}/definition_citation.md`} />
      </div>

      <div style={{ borderTop: '1px solid rgb(240,240,240)' }}>
        <MarkdownToJsx path={`${mdPath}/definition_source.md`} />
      </div>
    </>
  );
}

HazardText.propTypes = {
  place: PropTypes.string,
};
